import { ArrowIcon } from "../../../assets/icons"; 

export const workerCardButtons = [
    {
        path: `motivation`,
        text: "План сотрудника",
        icon: <ArrowIcon />,
        type: "secondary"
    },
    {
        path: `tasks`,
        text: "Задачи сотрудника",
        icon: <ArrowIcon />,
        type: "secondary"
    },
    {
        path: `table`,
        text: "Табель сотрудника",
        icon: <ArrowIcon />,
        type: "secondary"
    },
    {
        path: `reports`,
        text: "Отчеты по чек-листам",
        icon: <ArrowIcon />,
        type: "secondary"
    }
]
